module.exports = __webpack_public_path__ + "media/images/home/home_banner-fd9ba4450f61c33f18e3c8abdc72e3c2.jpg";